import Toast from '~/components/Toast.vue'
import {h, render} from 'vue'

export default defineNuxtPlugin(nuxtApp => {
    const colors = ['success', 'info', 'error', 'warning']
    const activeToasts: Array<{el: HTMLElement; vNode: any}> = []

    function createComponent(options: any) {
        const vNode = h(Toast, options)
        vNode.appContext = nuxtApp.vueApp._context
        const el = document.createElement('div')

        // Position the toast container to avoid overlapping
        el.style.position = 'fixed'
        el.style.zIndex = '9999'
        el.style.width = '100%'
        el.style.pointerEvents = 'none'

        render(vNode, el)
        document.body.appendChild(el)

        // Add to active toasts and position it
        activeToasts.push({el, vNode})
        positionToasts()

        return {vNode, el}
    }

    function positionToasts() {
        activeToasts.forEach((toast, index) => {
            const offset = index * 80 // 80px spacing between toasts
            toast.el.style.top = `${20 + offset}px` // Start 20px from top
            toast.el.style.left = '0'
            toast.el.style.right = '0'
        })
    }

    function removeToast(el: HTMLElement) {
        const index = activeToasts.findIndex(toast => toast.el === el)
        if (index > -1) {
            activeToasts.splice(index, 1)
            positionToasts() // Reposition remaining toasts
        }
    }

    function show(message: any, options: any = {}) {
        // Increase default timeout to 5 seconds
        options.timeout = options.timeout || 5000
        options.message = message

        const ctx: any = {}
        options.destroy = () => {
            render(null, ctx.el)
            removeToast(ctx.el)
            ctx.el.remove()
            ctx.vNode = null
        }
        const {vNode, el} = createComponent(options)
        Object.assign(ctx, {vNode, el})
    }

    function methods() {
        const methods: any = {}
        colors.forEach(color => (methods[color] = (message: any, options: any) => show(message, {color, ...options})))
        return methods
    }

    return {provide: {toast: methods()}}
})
